import { paginationSlice } from "@jugl-web/utils";
import {
  AnyAction,
  ThunkDispatch,
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { emptySplitApi } from "@web-src/features/api/createApi";
import appSlice from "@web-src/features/app/appSlice";
import authSlice from "@web-src/features/auth/authSlice";
import chatsSlice from "@web-src/modules/chats/store/chatsSlice";
import driveSlice from "@web-src/modules/drive/pages/DrivePage/driveSlice";
import { useDispatch } from "react-redux";

const combinedReducers = combineReducers({
  [emptySplitApi.reducerPath]: emptySplitApi.reducer,
  [appSlice.name]: appSlice.reducer,
  [chatsSlice.name]: chatsSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [driveSlice.name]: driveSlice.reducer,
  [paginationSlice.name]: paginationSlice.reducer,
});

type CombinedState = ReturnType<typeof combinedReducers>;

const rootReducer = (state: CombinedState | undefined, action: AnyAction) => {
  if (action.type === "auth/logout/fulfilled") {
    state = undefined;
  }
  return combinedReducers(state, action);
};

const middleware = [emptySplitApi.middleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useRtkQueryDispatch = useDispatch<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ThunkDispatch<any, unknown, AnyAction>
>;

export default store;
